import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import { SelectGenericFromTable } from '../universal/Axios';
import { observer } from "mobx-react"
import Button from '@mui/material/Button';
import SyncIcon from '@mui/icons-material/Sync';
import apiClient from '../../apiClient';
import { getStore } from '../../Store'
import Tooltip from '@mui/material/Tooltip';
const store = getStore();


const ComparativeSetTable = ({ selectComparativeSetID, selectedComparativeSetID }) => {
    //const comparativeSetData = store.comparativeSetes
    const [comparativeSetData, setComparativeSetData] = useState(undefined);

    useEffect(() => {
        SelectGenericFromTable("select * from comparative_set;", setComparativeSetData)
    }, []);

    if (comparativeSetData === undefined) {
        return (<p>loading...</p>)
    }

    const syncComparativeSet = (comparative_set_id) => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Update_Comparative_Set",
                "comparative_set_id": comparative_set_id,
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully updated comparative set!")
        }).catch(function (error) {
            store.updateErrorMessage("Error while triggering comparative set")
        })
    }

    const comparativeSetColumns = [
        {
            field: 'actions',
            headerName: 'Actions',
            width: 70,
            renderCell: (params) => (
                <>
                    {
                        <Tooltip title="Sync DNC Info">
                            <Button
                                href="#"
                                onClick={() => syncComparativeSet(params.row.id)}
                            >
                                <SyncIcon />
                            </Button>
                        </Tooltip>
                    }
                </>
            ),
        },
        {
            field: 'id',
            headerName: 'ID',
            width: 420,
            renderCell: (params) => (
                <a
                    href={'edit-comparative-set?id=' + params.row.id}
                >
                    {params.row.id}
                </a>
            ),
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 180,
        },
        {
            field: 'created_date',
            headerName: 'Created Date',
            width: 140,
        }
    ];

    let comparativeSetDataRows = comparativeSetData?.filter(data => data != null).map((comparativeSet) =>
    ({   
        id: comparativeSet.id,
        description: comparativeSet.description,
        run_date: comparativeSet.run_date,
    }))

    return (
        <DataGrid
            disableSelectionOnClick
            rows={comparativeSetDataRows}
            columns={comparativeSetColumns}
            pagination={true}
            checkboxSelection={selectComparativeSetID !== undefined}
            selectionModel={selectedComparativeSetID}
            onSelectionModelChange={(selectedBaselineAudiences) => {
                if (selectedBaselineAudiences.length > 0) {
                    selectComparativeSetID(selectedBaselineAudiences[selectedBaselineAudiences.length - 1]);
                }
                else {
                    selectComparativeSetID(selectedBaselineAudiences)
                }
            }}
            maxSelectionRows={1}
            initialState={{
              sorting: {
                    sortModel: [{ field: 'created_date', sort: 'desc' }, { field: 'id', sort: 'desc'}],
              },
            }}
      />
    )
};

export { ComparativeSetTable };
